// Func = limiting Scope for this file
(function(){
	function scrollMenu(){
		let scrollpos = window.scrollY
		const $menuH = document.querySelector('#header')
		const $slide_height = document.querySelector('#header')
		const menu_height = $slide_height.offsetHeight

		const add_class_on_scroll = () => $menuH.classList.add('scroll')
		const remove_class_on_scroll = () => $menuH.classList.remove('scroll')

		window.addEventListener('scroll', function(){
		scrollpos = window.scrollY;

		if (scrollpos >= menu_height) {
			add_class_on_scroll()
		}else {
			remove_class_on_scroll()
		}
		})
		
	}
	function resizeWindow(){

	}
	function scrollDown(){
		//Scroll animations
		const top = window.scrollY;
		let animatedEl = document.getElementsByClassName('animate-fade-2');
		const h = window.innerHeight;
		var i;
		for (i = 0; i < animatedEl.length; i++) {
			var viewportOffset = animatedEl[i].getBoundingClientRect();
			let topPos = viewportOffset.top;
			//animatedEl[i].innerHTML = topPos;
			if(topPos <= h*0.8){
				animatedEl[i].classList.add('fade-in','visible');
			}
		}
	}

	/*****************************************************/

	let observer_item = document.querySelector(".sub-menu");
	let bodyid = document.body.id;
	let observable = document.getElementById('submenu-scroll');

	if (observer_item){
		let options = {
			root: null, // relative to document viewport 
			rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0 // visible amount of item shown in relation to root
		};

		function handler(entries, observer) {
			let entry;
			entries.forEach(function(entry){
				if (entry.isIntersecting) {
					observer_item.classList.remove("scroll");
				} else {
					observer_item.classList.add("scroll");
				}
				});
		}

		let observer = new IntersectionObserver(handler, options);
		observer.observe(observable);
	}

	//Add ada map link
	function addAdaMapLink ( class_name = '', label = 'View ADA MAP', href = '/ada-map', container= 'myMap') {
		let block_to_insert;
		 
		block_to_insert = document.createElement('div');
		block_to_insert.setAttribute('class', 'note');
		block_to_insert.innerHTML = '<a class="btn '+class_name+'" href="'+href+'">'+label+'</a>';

		console.log(block_to_insert);

		setTimeout(function(){ 
			document.getElementById(container).appendChild(block_to_insert); 
			block_to_insert.classList.add('active');
		}, 700);

	}

	/******************************************************/

	$(document).ready(function () {

		$('.btn-donation-form').click(function(e){
			e.preventDefault();
			var hash = this.getAttribute("href");
			setTimeout(()=>{
				var hashTop = $(hash).offset().top;
				$('html,body').animate({scrollTop:hashTop-150},1000);
			},400)
			
		})


		//tablet menu
		document.querySelector('#menu-btn').addEventListener('click', ()=>{
			document.querySelector('.container-menu').classList.add('active');
		});

		document.querySelector('.close-menu').addEventListener('click', ()=>{
			document.querySelector('.container-menu').classList.remove('active');
		});

		let mapid = document.getElementById('myMap');
		if (mapid){
			addAdaMapLink('','View list of ATTRACTIONS & ENTERTAINMENT');
		}
		
		//careers shortcode
		var show_info = document.querySelectorAll('.show-career-js');
		var info_box= document.querySelectorAll('.career__info-js');

		for(let i=0; i < show_info.length; i++){
			show_info[i].addEventListener('click', function(){
				if(this.classList.contains('showed')){
					this.textContent = 'Learn More'
					let item = this.getAttribute('data-info');
					document.querySelector(item).classList.remove('active-info')
					this.classList.remove('showed')
				}
				else{
					let item = this.getAttribute('data-info');
					document.querySelector(item).classList.add('active-info')
					this.classList.add('showed');
					this.textContent = 'Close';
				}
			})
		}


		if(document.querySelector('.btn-job-application')){
			document.querySelector('.btn-job-application').addEventListener('click', function(){
				document.querySelector('.job-application-form').classList.add('show-form');
			})
			document.querySelector('.btn-close-form').addEventListener('click', function(){
				document.querySelector('.job-application-form').classList.remove('show-form');
			})
		}
		if(document.querySelector('.btn-donation-form')){
			document.querySelector('.btn-donation-form').addEventListener('click', function(){
				document.querySelector('#donationform').classList.add('view-form');
				$('.close-form-donation').fadeIn();
			})
			document.querySelector('.close-form-donation').addEventListener('click', function(){
				document.querySelector('#donationform').classList.remove('view-form');
				$('.close-form-donation').fadeOut();
			})
		}

		//careers form
		$('#showExtraFields').on('click', function(){
			$('.extraFields').toggle();
		})

		//submenu about us
		$('.about-submenu a').click(function (e) { 
			e.preventDefault();
			let target = $(this).attr('href');
			$('.about-submenu a').removeClass('active');
			$(this).addClass('active');
			console.log(target);
			setTimeout(function() {
				$('html, body').animate({scrollTop: $(target).offset().top - ($('header').height() + 80)}, 800);
			}, 700);
		});

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: new Date(2021, 5 - 1, 1),
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			minDate: new Date(2021, 5 - 1, 1),
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	// $(window).on('load', function() {});

}());